import api from './api';

class ProductService {
    async getProducts(params = {}) {
        return api.get('products/', { params });
    }

    async getProduct(id) {
        return api.get(`products/${id}/`);
    }
}

export default new ProductService();
